var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldValidationFailedBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46042",
    "data-name": "Group 46042",
    transform: "translate(-620.844 -36.15)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2259",
    "data-name": "Ellipse 2259",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(620.844 36.15)",
    fill: "#c30000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation",
    "data-name": "Icon awesome-exclamation",
    d: "M4.319,6.937a1.468,1.468,0,0,1-1.6,1.285,1.468,1.468,0,0,1-1.6-1.285,1.468,1.468,0,0,1,1.6-1.285A1.468,1.468,0,0,1,4.319,6.937ZM1.31.4l.272,4.368a.446.446,0,0,0,.479.366H3.384a.446.446,0,0,0,.479-.366L4.134.4A.434.434,0,0,0,3.656,0H1.788A.434.434,0,0,0,1.31.4Z",
    transform: "translate(626.122 40.04)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldValidationFailedBadge);
export default __webpack_public_path__ + "static/media/field_validation_failed_badge.36dde5f4075e7130f085529360566649.svg";
export { ForwardRef as ReactComponent };